export const colors = {
	r4u_red: 'rgba( 255, 72, 124,1)',
	r4u_orange: 'rgba(253, 170, 76,1)',
	r4u_green: 'rgba(65, 216, 191,1)',
	r4u_yellow: 'rgba(253, 224, 76,1)',
	r4u_blue: 'rgba(59, 59, 182)',
	not_highlighted: 'rgba(59,59,182,0.075)',
};

export const hexaColors = {
	inclusion: {
		property: 'equality',
		stops: [
			[0, colors.not_highlighted],
			[0.0001, colors.r4u_red],
			[0.3, colors.r4u_red],
			[0.6, colors.r4u_orange],
			[1, colors.r4u_green],
		],
	},
	walkability: {
		property: 'walkdistance',
		stops: [
			[-0.1, colors.not_highlighted],
			[1200, colors.r4u_green],
			[3600, colors.r4u_orange],
			[7200, colors.r4u_red],
		],
	},
	rollability: {
		property: 'wheelchairdistance',
		stops: [
			[-0.1, colors.not_highlighted],
			[1200, colors.r4u_green],
			[3600, colors.r4u_orange],
			[7200, colors.r4u_red],
		],
	},
};

const colorByWidth = [
	'step',
	['to-number', ['case', ['has', 'width'], ['get', 'width'], 0]],
	colors.not_highlighted,
	2,
	colors.r4u_red,
	80,
	colors.r4u_orange,
	140,
	colors.r4u_yellow,
	200,
	colors.r4u_green,
];

export const sidewalkColors = {
	roughness: [
		'match',
		['get', 'surface-smoothness'],
		'green',
		colors.r4u_green,
		'yellow',
		colors.r4u_yellow,
		'orange',
		colors.r4u_orange,
		'red',
		colors.r4u_red,
		colors.not_highlighted,
	],
	obstacles: [
		'match',
		['get', 'surface-smoothness'],
		'green',
		colors.not_highlighted,
		'yellow',
		colors.r4u_yellow,
		'orange',
		colors.r4u_orange,
		'red',
		colors.r4u_red,
		colors.not_highlighted,
	],
	width: colorByWidth,
	curbs: [
		'case',
		['<', ['to-number', ['get', 'curb-height']], 3],
		'#36d3c1',
		['all', ['>=', ['to-number', ['get', 'curb-height']], 3], ['<=', ['to-number', ['get', 'curb-height']], 4]],
		'#ffa55c',
		['>', ['to-number', ['get', 'curb-height']], 4],
		'#ff477b',
		colors.not_highlighted,
	],
	paving: [
		'match',
		['get', 'surface'],
		'asphalt',
		'darkgrey',
		'bricks',
		'orange',
		'cobblestone',
		'black',
		'sett',
		'black',
		'concrete',
		'blue',
		'concrete_plates',
		'lightblue',
		'dirt',
		'brown',
		'grass',
		'green',
		'grass_paver',
		'darkgreen',
		'fine_gravel',
		'red',
		'gravel',
		'red',
		'compacted',
		'red',
		'unpaved',
		'red',
		'paving_stones',
		'violet',
		'wood',
		'lime',
		'metal',
		'pink',
		colors.not_highlighted,
	],
	incline: [
		'step',
		['abs', ['to-number', ['case', ['has', 'steep'], ['get', 'steep'], 0]]],
		colors.not_highlighted,
		0.5,
		colors.r4u_yellow,
		3,
		colors.r4u_orange,
		7,
		colors.r4u_red,
	],
};
